import { gql } from 'apollo-angular';

export var committee_calendar_dates = gql`
  query committeeCalendarDates(
    $start: Date!
    $end: Date!
    $pipestart: Mixed!
    $pipeend: Mixed!
  ) {
    statusSequenceDetails(sequence_name: "Closing") {
      id
      index
      status {
        id
        name
      }
    }
    fundClosingDates(close_date: { to: $start, from: $end }) {
      id
      name
      close_date
    }
    projectDates(
      date: { to: $start, from: $end }
      hasDateType: {
        column: NAME
        operator: IN
        value: ["Capital Re-Approved", "Full Closed"]
      }
      hasDateClass: { column: NAME, operator: IN, value: ["actual", "target"] }
    ) {
      id
      date
      project {
        id
        name
        participants {
          person {
            id
          }
        }
      }
      dateType {
        id
        name
      }
      dateClass {
        id
        name
      }
    }
    dispositionPipelineDates(
      initial_target: false
      date: { to: $start, from: $end }
    ) {
      id
      date
      initial_target
      target
      pipelineMilestone {
        pipeline {
          id
          name
        }
        milestone {
          id
          name
        }
      }
      disposition {
        project {
          id
          name
          participants {
            person {
              id
              name
            }
          }
        }
      }
    }
    pipelineMilestoneDates(
      hasPipeline: { column: NAME, operator: EQ, value: "Closing" }
      hasMilestone: {
        column: NAME
        operator: IN
        value: [
          "Placement Committee Reviewed"
          "Screening Committee"
          "Capital Committee"
          "Closed"
        ]
      }
      hasPipelineProjectDates: {
        AND: [
          { column: INITIAL_TARGET, operator: EQ, value: false }
          { column: DATE, operator: GTE, value: $pipestart }
          { column: DATE, operator: LTE, value: $pipeend }
        ]
      }
    ) {
      id
      pipeline {
        id
        name
      }
      milestone {
        id
        name
      }
      pipelineProjectDates(
        date: { to: $start, from: $end }
        initial_target: false
      ) {
        id
        date
        target
        pipelineProject {
          project {
            id
            name
            projectStatuses(sequence_name: "Closing") {
              status_id
            }
            participants {
              person {
                id
              }
            }
          }
        }
      }
    }
    projectSubstatusDates(
      where: {
        HAS: {
          relation: "subsequence",
          condition: { column: "name", operator: IN, value: ["Closing Deadline"]}
        }
      }
    ) {
      date
      utc_time
      timezone
      projectStatus {
        project {
          id
          name
          participants {
            person {
              id
              name
            }
          }
        }
      }
      substatus {
        name
        subsequence {
          name
        }
      }
    }
  }
`;
